import { CompCardCore } from '../core/card/comp'

export const CompCard = CompCardCore
